import React from "react";
import { FixedSizeList } from "react-window";
import { ItemVersionReport } from "./ItemVersionReport";

const ITEM_SIZE = 40;

export function VirtualVersionList({ moveCompany, items, companys }) {
  const itemCount = items.length;
  const height = Math.min(window.innerHeight * 0.7, itemCount * ITEM_SIZE);

  return (
    <FixedSizeList
      height={height}
      itemCount={itemCount}
      itemSize={ITEM_SIZE}
      width="100%"
      overflowY={"auto"}
      overflowX={"hidden"}
    >
      {({ index, style }) => {
        const ver = items[index];
        if (!ver) {
          return null;
        }
        return (
          <div style={style}>
            <ItemVersionReport
              ver={ver}
              moveCompany={moveCompany}
              companys={companys}
            />
          </div>
        );
      }}
    </FixedSizeList>
  );
}
